<div class="modal">
  <div class="card">
    <div class="card-header">
      <div class="card-title">Odabir načina otpreme</div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
              <app-dropdown [options]="shippingMethodOptions"
                            [title]="'Izaberi'"
                            [parentForm]="form"
                            [parentControl]="'shippingMethod'"
                            class="me-3"></app-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [disabled]="form.invalid">Potvrdi</button>
    </div>
  </div>
</div>